export const merchantDelegationMutations = {
  setMerchantDelegationFormStatus(state, payload) {
    state.merchantDelegationFormStatus = payload;
  },
  setMerchantDelegationIsEdit(state, payload) {
    state.merchantDelegationIsEdit = payload
  },
  setMerchantDelegationSelectedForEdit(state, payload) {
    state.merchantDelegationSelectedForEdit = payload
  },
};